import React from 'react';


const Educacao = (props) => {
	
	const { logo, altLogo, nomeInstituicaoEnsino, nomeCurso, periodo, local } = props;
	
	return(
		<div className="curso">
			<div id="logo-faculdade">
				<img src={logo} className="img-fluid" aria-hidden="true" alt={altLogo} />
			</div>
			<div id="info-graduacao">
				<h5>{nomeInstituicaoEnsino}</h5>
				<b>{nomeCurso}</b>
				<p>{periodo} <br/> {local}</p>
			</div>
		</div>
	)
}

export default Educacao;
